import { clsx } from 'clsx';
import { useContext } from 'react';

import { paddingCSSVars } from '../../../utils/spacing';
import type { ModalFooterProps } from '../modal.types';
import { ModalContext } from '../modalContext';
import styles from './modalFooter.module.css';

export function ModalFooter({
  children,
  className,
  'data-testid': testId,
  id,
  style,
}: ModalFooterProps) {
  const { variant } = useContext(ModalContext);

  return (
    <div
      className={clsx(
        className,
        [styles['modalFooter']],
        variant === 'full-screen' && styles[`modalFooter__${variant}`]
      )}
      id={id}
      style={{
        ...paddingCSSVars({
          px: 24,
          py: 16,
        }),
        ...style,
      }}
      data-id="modal-footer"
      data-testid={testId}
    >
      {children}
    </div>
  );
}
